import React, { ReactNode } from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';

type EmptyProps = {
  image: string;
  title?: ReactNode;
  body?: ReactNode;
};

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 550px;
  margin: 0 auto;
  text-align: center;
`;

const Empty = ({ image, title = null, body = null }: EmptyProps) => (
  <Wrap>
    <img
      src={image}
      style={{ width: 400, height: 211, alignSelf: 'center', pointerEvents: 'none' }}
      alt=""
    />
    {title && <Typography.Title level={3}>{title}</Typography.Title>}
    {body && <Typography.Paragraph>{body}</Typography.Paragraph>}
  </Wrap>
);

export default Empty;
